module.exports = __webpack_public_path__ + "img/logo.6850a1de.png";